import { Feature } from 'ol';
import { Sld } from '../data/sld';

export class Record {
  id: string|undefined;
  title: string|undefined;
  resourceUrl: string|undefined;
  published: string|undefined;
  bbox: any|undefined;
  feature: Feature|undefined;
  wmsUrl: string|undefined;
  wmsLayerName: string|undefined;
  wmsMapLayer: any|undefined;
  wmsopacity: number|undefined;
  sld: Sld|undefined;
  defaultSld: Sld|undefined;
  itemHref: string|undefined;
  collection: string|undefined;
  properties: any;
}

